import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Financiar/DeconturiModels.cs ----------

export type CostCenter = 'Productie' | 'Vanzari' | 'Administrativ' | 'Logistica'
export const COST_CENTERS: { value: CostCenter; label: string }[] = [
  { value: 'Productie', label: 'Producție' },
  { value: 'Vanzari', label: 'Vânzări' },
  { value: 'Administrativ', label: 'Administrativ' },
  { value: 'Logistica', label: 'Logistică' },
]

export type ExpenseReportStatus = 'Draft' | 'Depusa' | 'Aprobat' | 'Respins' | 'Programat' | 'Decontat'

export interface ExpenseCategory { id: string; code: string; name: string; deductible: boolean; isActive: boolean }
export type SaveExpenseCategoryPayload = Omit<ExpenseCategory, 'id'>

export const listExpenseCategories = () => api.get<ExpenseCategory[]>('/financiar/categorii-cheltuieli').then((r) => r.data)
export const createExpenseCategory = (payload: SaveExpenseCategoryPayload) =>
  api.post<{ id: string }>('/financiar/categorii-cheltuieli', payload).then((r) => r.data)
export const updateExpenseCategory = (id: string, payload: SaveExpenseCategoryPayload) =>
  api.put(`/financiar/categorii-cheltuieli/${id}`, payload)

export interface Expense {
  id: string; date: string; employeeUserId: string; employeeName: string
  categoryId: string; categoryName: string; description: string
  amount: number; currency: string; exchangeRate: number
  costCenter: CostCenter; department: string | null
  attachmentFileName: string; expenseReportId: string | null
}

export interface CreateExpensePayload {
  date: string; categoryId: string; description: string; amount: number; currency: string; exchangeRate: number
  costCenter: CostCenter; department: string | null; file: File
}

export const listMyExpenses = () => api.get<Expense[]>('/financiar/cheltuieli/mele').then((r) => r.data)
export const listAllExpenses = () => api.get<Expense[]>('/financiar/cheltuieli/toate').then((r) => r.data)
export const listMyAvailableExpenses = () => api.get<Expense[]>('/financiar/cheltuieli/mele/disponibile').then((r) => r.data)

export const createExpense = (payload: CreateExpensePayload) => {
  const form = new FormData()
  form.append('date', payload.date)
  form.append('categoryId', payload.categoryId)
  form.append('description', payload.description)
  form.append('amount', String(payload.amount))
  form.append('currency', payload.currency)
  form.append('exchangeRate', String(payload.exchangeRate))
  form.append('costCenter', payload.costCenter)
  if (payload.department) form.append('department', payload.department)
  form.append('file', payload.file)
  return api.post<{ id: string }>('/financiar/cheltuieli', form, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data)
}

export const getExpenseAttachment = (id: string) =>
  api.get<Blob>(`/financiar/cheltuieli/${id}/atasament`, { responseType: 'blob' }).then((r) => r.data)
export const deleteExpense = (id: string) => api.delete(`/financiar/cheltuieli/${id}`)

export interface ExpenseReportListItem {
  id: string; number: string; employeeUserId: string; employeeName: string; status: ExpenseReportStatus
  submittedAt: string | null; scheduledPaymentDate: string | null; total: number
}
export interface ExpenseReportDetail extends ExpenseReportListItem {
  allocatedFromAdvance: number; remainderOwed: number; lines: Expense[]
}
export interface SubmitExpenseReportResult { pendingApproval: boolean }
export interface EmployeeAdvanceBalance { balance: number }

export const listMyExpenseReports = () => api.get<ExpenseReportListItem[]>('/financiar/deconturi/mele').then((r) => r.data)
export const listAllExpenseReports = () => api.get<ExpenseReportListItem[]>('/financiar/deconturi/toate').then((r) => r.data)
export const getExpenseReport = (id: string) => api.get<ExpenseReportDetail>(`/financiar/deconturi/${id}`).then((r) => r.data)
export const getMyAdvanceBalance = () => api.get<EmployeeAdvanceBalance>('/financiar/deconturi/mele/sold-avans').then((r) => r.data)

export const createExpenseReport = (expenseIds: string[]) =>
  api.post<{ id: string }>('/financiar/deconturi', { expenseIds }).then((r) => r.data)
export const submitExpenseReport = (id: string) =>
  api.post<SubmitExpenseReportResult>(`/financiar/deconturi/${id}/depune`).then((r) => r.data)
export const scheduleExpenseReportPayment = (id: string, scheduledPaymentDate: string) =>
  api.post(`/financiar/deconturi/${id}/programeaza-plata`, { scheduledPaymentDate })
export const payExpenseReport = (id: string, cashAccountId: string, currency: string, exchangeRate: number) =>
  api.post(`/financiar/deconturi/${id}/plateste`, { cashAccountId, currency, exchangeRate })
